module.exports = __webpack_public_path__ + "assets/logo.d88aa476.svg";